import API_BASE_URL from '../api';

async function parseJsonResponse(response) {
  const text = await response.text();

  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = text;
  }

  if (!response.ok) {
    throw new Error(
      typeof data === 'object' && data?.detail
        ? data.detail
        : `HTTP ${response.status}`
    );
  }

  return data;
}

export async function fetchKnowledgeBaseCategories(language = 'uk') {
  const response = await fetch(
    `${API_BASE_URL}/kb/categories?language=${encodeURIComponent(language)}`
  );

  return parseJsonResponse(response);
}

export async function fetchKnowledgeBaseCategoryArticles(categorySlug, language = 'uk') {
  const response = await fetch(
    `${API_BASE_URL}/kb/categories/${encodeURIComponent(categorySlug)}/articles?language=${encodeURIComponent(language)}`
  );

  return parseJsonResponse(response);
}

export async function fetchKnowledgeBaseArticle(articleSlug, language = 'uk') {
  const response = await fetch(
    `${API_BASE_URL}/kb/articles/${encodeURIComponent(articleSlug)}?language=${encodeURIComponent(language)}`
  );

  return parseJsonResponse(response);
}

export async function searchKnowledgeBase(query, language = 'uk') {
  const response = await fetch(
    `${API_BASE_URL}/kb/search?q=${encodeURIComponent(query)}&language=${encodeURIComponent(language)}&limit=20`
  );

  return parseJsonResponse(response);
}
